const eventSchemas = {
  default_properties: ['page_category', 'product_group', 'page_type', 'content_group', 'local_currency', 'language',
    'remite', 'campaign_name', 'campaign_channel_name', 'campaign_channel_type'],
  identify: ['user_id', 'email_id'],
  consent:[
    // abandoned cart
    'action_cartabandoned_opt_in',
    'category_cartabandoned_opt_in',
    'valid_until_cartabandoned_opt_in',
    // crosselling
    'action_crosselling_opt_in',
    'category_crosselling_opt_in',
    'valid_until_crosselling_opt_in',
    // newsletter
    'action_newsletter_opt_in',
    'category_newsletter_opt_in',
    'valid_until_newsletter_opt_in'
  ],
  anonymize: [],
  view_homepage: [],
  view_other: [],
  view_category: ['category_id', 'title', 'category_level_1', 'category_level_2', 'category_level_3'],
  view_search_results: ['search_term', 'catalogs'],
  view_item: [
    'destination_name',
    'destination_type',
    'destination_country',
    'total_passengers',
    'number_of_adults',
    'number_of_kids',
    'number_of_babies',
    'start_date',
    'end_date',
    'travel_month',
    'travel_week',
    'duration',
    'search_type',
    'total_price_local_currency',
    'local_currency',
    'currency',
    'product_list',
     //
    'product_id',
    'product_name',
    'product_type',
    'product_reference_price',
    'product_price',
    'product_currency',
    'product_variant',
    'product_board',
    'product_rooms',
    'product_nights',
    'quantity',
    'type_of_discount',
    'product_rating',
    'product_category',
  ],
  checkout: [
    'check_out_status',
    'step_number',
    'step_title',
    'error_message',
    'error_action',
    'has_ancillaries',
    //
    'page_category',
    'page_type',
    'product_group',
    'destination_name',
    'destination_type',
    'destination_country',
    'total_passengers',
    'number_of_adults',
    'number_of_kids',
    'number_of_babies',
    'start_date',
    'end_date',
    'travel_month',
    'travel_week',
    'duration',
    'search_type',
    'total_price_reference_currency',
    'total_price_local_currency',
    'local_currency',
    'currency',
    'product_list',
    //
    'product_id',
    'product_name',
    'product_type',
    'product_reference_price',
    'product_price',
    'product_currency',
    'product_variant',
    'product_board',
    'product_rooms',
    'product_nights',
    'quantity',
    'type_of_discount',
    'product_rating',
    'product_category',
  ],
  cart_update: [
    'update_cart_status',
    'action',
    'item_service_update',
    'step_number',
    'step_title',
    //
    'page_category',
    'page_type',
    'product_group',
    'destination_name',
    'destination_type',
    'destination_country',
    'total_passengers',
    'number_of_adults',
    'number_of_kids',
    'number_of_babies',
    'start_date',
    'end_date',
    'travel_month',
    'travel_week',
    'duration',
    'search_type',
    'total_price_reference_currency',
    'total_price_local_currency',
    'local_currency',
    'currency',
    'product_list',
    //
    'product_id',
    'product_name',
    'product_type',
    'product_reference_price',
    'product_price',
    'product_currency',
    'product_variant',
    'product_board',
    'product_rooms',
    'product_nights',
    'quantity',
    'type_of_discount',
    'product_rating',
    'product_category',
  ],
  purchase: [
    'purchase_id',
    'purchase_status',
    'error_type',
    'error_gateway',
    'payment_method',
    'card_type',
    'has_ancillaries',
    'ref',
    'coupon_code',
    //
    'page_category',
    'page_type',
    'product_group',
    'destination_name',
    'destination_type',
    'destination_country',
    'total_passengers',
    'number_of_adults',
    'number_of_kids',
    'number_of_babies',
    'start_date',
    'end_date',
    'travel_month',
    'travel_week',
    'duration',
    'search_type',
    'total_price_reference_currency',
    'total_price_local_currency',
    'local_currency',
    'currency',
    'product_list',
  ],
  'double_opt_in': [
    'action',
    'email',
    'source',
    'consent_list',
  ],
};

const propertyMap = {
  view_item: {
    'search_type': 'product_group',
    'start_date': 'formattedDateIn',
    'end_date': 'formattedDateOut',
    //
    'product_id': 'prditemhotel-product_id',
    'product_name': 'prditemhotel-product_name',
    'product_type': 'prditemhotel-product_type',
    'product_reference_price': 'prditemhotel-product_reference_price',
    'product_price': 'prditemhotel-product_price',
    'product_currency': 'prditemhotel-product_currency',
    'product_variant': 'prditemhotel-product_variant',
    'product_board': 'prditemhotel-product_board',
    'product_rooms': 'prditemhotel-product_rooms',
    'product_nights': 'prditemhotel-product_nights',
    'quantity': 'prditemhotel-quantity',
    'type_of_discount': 'prditemhotel-type_of_discount',
    'product_rating': 'prditemhotel-product_rating',
    'product_category': 'prditemhotel-product_category',
  },
  checkout: {
    'check_out_status': 'checkOutStatus',
    'step_number': 'stepNumber',
    'step_title': 'pagegroup',
    //
    'search_type': 'product_group',
    'start_date': 'formattedDateIn',
    'end_date': 'formattedDateOut',
    //
    'product_id': 'prditemhotel-product_id',
    'product_name': 'prditemhotel-product_name',
    'product_type': 'prditemhotel-product_type',
    'product_reference_price': 'prditemhotel-product_reference_price',
    'product_price': 'prditemhotel-product_price',
    'product_currency': 'prditemhotel-product_currency',
    'product_variant': 'prditemhotel-product_variant',
    'product_board': 'prditemhotel-product_board',
    'product_rooms': 'prditemhotel-product_rooms',
    'product_nights': 'prditemhotel-product_nights',
    'quantity': 'prditemhotel-quantity',
    'type_of_discount': 'prditemhotel-type_of_discount',
    'product_rating': 'prditemhotel-product_rating',
    'product_category': 'prditemhotel-product_category',
  },
  cart_update: {
    'update_cart_status': 'updateCartStatus',
    'item_service_update': 'itemServiceUpdate',
    'step_number': 'stepNumber',
    'step_title': 'pagegroup',
    //
    'search_type': 'product_group',
    'start_date': 'formattedDateIn',
    'end_date': 'formattedDateOut',
    //
    'product_id': 'prditemhotel-product_id',
    'product_name': 'prditemhotel-product_name',
    'product_type': 'prditemhotel-product_type',
    'product_reference_price': 'prditemhotel-product_reference_price',
    'product_price': 'prditemhotel-product_price',
    'product_currency': 'prditemhotel-product_currency',
    'product_variant': 'prditemhotel-product_variant',
    'product_board': 'prditemhotel-product_board',
    'product_nights': 'prditemhotel-product_nights',
    'quantity': 'prditemhotel-quantity',
    'type_of_discount': 'prditemhotel-type_of_discount',
    'product_rating': 'prditemhotel-product_rating',
    'product_category': 'prditemhotel-product_category',
  },
  purchase: {
    'purchase_status': 'status',
    //
    'search_type': 'product_group',
    'start_date': 'formattedDateIn',
    'end_date': 'formattedDateOut',
  },
};

const attributeToTransfer= {
  product_item: [
    'page_category', 'product_group', 'page_type', 'content_group', 'local_currency', 'language',
    'remite', 'campaign_name', 'campaign_channel_name', 'campaign_channel_type',
    //
    'destination_name',
    'destination_type',
    'destination_country',
    'total_passengers',
    'number_of_adults',
    'number_of_kids',
    'number_of_babies',
    'start_date',
    'end_date',
    'travel_month',
    'travel_week',
    'duration',
    'search_type',
    'currency',
  ]
};

export { eventSchemas, propertyMap, attributeToTransfer};

